module.exports = __webpack_public_path__ + "static/media/terby.png";